import React, { useEffect, useState, useCallback } from 'react';
import DownloadedElement from '../downloaded_element/DownloadedElement';
import EmptyList from './Empty';
import PouchDB from 'pouchdb-browser';
import PouchdbFind from 'pouchdb-find';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './DownloadedList.css';
//import { closeMenu } from '../functions/functions';
//Notifications
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//Delete confirmation
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const DownloadedList = () => {
  PouchDB.plugin(PouchdbFind);
  const [db, setdb] = useState(PouchDB('gestor_contenidos_db'));
  const [datos, setData] = useState([]);
  const [down, setDown] = useState(false);
  const [search, setSearch] = useState('');
  const [query_search, setQuerySearch] = useState('');
  const [inSearch, setInSearch] = useState(false);
  const [is_type, setIsType] = useState(true);
  const [numRes, setNumRes] = useState(0);
  const { t, i18n } = useTranslation();

  const submit = (object_id, nombre) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{t('modal_eliminar_titulo')}</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={onClose}
                >
                  <span aria-hidden="true">
                    <i className="fal fa-times"> </i>
                  </span>
                </button>
              </div>
              <div className="modal-body">
                {t('modal_eliminar_mensaje')} <strong>"{nombre}"</strong> ?
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary waves-effect waves-themed"
                  onClick={onClose}
                >
                  {t('modal_eliminar_cancelar')}
                </button>
                <button
                  type="button"
                  className="btn btn-danger waves-effect waves-themed"
                  onClick={() => {
                    deleteObject(object_id);
                    onClose();
                  }}
                >
                  {t('modal_eliminar_borrar')}
                </button>
              </div>
            </div>
          </div>
        );
      }
    });
  };

  const findObject = e => {
    e.preventDefault();
    if (search.length === 0) {
      get_db_elements();
    } else {
      setInSearch(true);
      setQuerySearch(search);
      let regexp = new RegExp(search, 'i');
      db.find(
        {
          selector: { 'object.general.title.value': { $regex: regexp } }
        },
        function(err, res) {
          if (err) {
            // handle error
          } else {
            setData(res.docs);
            setNumRes(res.docs.length);
          }
        }
      );
    }
  };

  const updateSearch = e => {
    setSearch(e.target.value);
  };

  const get_db_elements = useCallback(() => {
    db.createIndex({
      index: { fields: ['date_downloaded', 'object.group_type'] }
    }).then(result => {
      return db
        .find({
          selector: {
            $and: [
              { 'object.group_type': { $eq: null } },
              { date_downloaded: { $gt: null } }
            ]
          },
          sort: [{ date_downloaded: 'desc' }]
        })
        .then(res => {
          setIsType(res.docs.length);
          setData(res.docs);
          res.docs.length === 0 ? setDown(false) : setDown(true);
        })
        .catch(err => {
          console.log(err);
        });
    });
  }, [db]);

  const get_file_type_elements = file_type => {
    switch (file_type) {
      case 'docs':
        return db
          .find({
            selector: {
              $or: [
                { 'object.technical.0.format.extension': { $eq: 'pdf' } },
                { 'object.technical.0.format.extension': { $eq: 'doc' } }
              ],
              'object.group_type': { $eq: null }
            }
          })
          .then(res => {
            setIsType(res.docs.length);
            setData(res.docs);
          })
          .catch(err => {});

      case 'img':
        return db
          .find({
            selector: {
              $or: [
                { 'object.technical.0.format.extension': { $eq: 'bmp' } },
                { 'object.technical.0.format.extension': { $eq: 'gif' } },
                { 'object.technical.0.format.extension': { $eq: 'png' } },
                { 'object.technical.0.format.extension': { $eq: 'jpg' } }
              ],
              'object.group_type': { $eq: null }
            }
          })
          .then(res => {
            setIsType(res.docs.length);
            setData(res.docs);
          })
          .catch(err => {});

      case 'audio':
        return db
          .find({
            selector: {
              $or: [{ 'object.technical.0.format.extension': { $eq: 'mp3' } }],
              'object.group_type': { $eq: null }
            }
          })
          .then(res => {
            setIsType(res.docs.length);
            setData(res.docs);
          })
          .catch(err => {});

      case 'others':
        return db
          .find({
            selector: {
              $nor: [
                { 'object.technical.0.format.extension': { $eq: 'pdf' } },
                { 'object.technical.0.format.extension': { $eq: 'doc' } },
                { 'object.technical.0.format.extension': { $eq: 'mp3' } },
                { 'object.technical.0.format.extension': { $eq: 'bmp' } },
                { 'object.technical.0.format.extension': { $eq: 'gif' } },
                { 'object.technical.0.format.extension': { $eq: 'png' } },
                { 'object.technical.0.format.extension': { $eq: 'jpg' } }
              ],
              'object.group_type': { $eq: null }
            }
          })
          .then(res => {
            setIsType(res.docs.length);
            setData(res.docs);
          })
          .catch(err => {});

      default:
        return db
          .find({
            selector: {
              'object.group_type': { $eq: null },
              date_downloaded: { $gt: null }
            },
            sort: [{ date_downloaded: 'desc' }]
          })
          .then(res => {
            setIsType(res.docs.length);
            setData(res.docs);
          })
          .catch(err => {});
    }
  };

  useEffect(() => {
    //closeMenu();
    window.scrollTo(0, 0);
    i18n.changeLanguage(localStorage.getItem('lang'));
    get_db_elements();
  }, [i18n,get_db_elements]);

  const deleteObjetcData = object_id => {
    setData(
      datos.filter(function(el) {
        return el.object.id !== object_id;
      })
    );
  };

  const deleteObject = object_id => {
    db.get(object_id)
      .then(function(doc) {
        db.remove(doc).then(() => {
          //declaracion
          const tmpDBName = 'tmpdb'; //db temporal
          const deleteFilter = (doc, req) => !doc._deleted;

          //  limpieza
          //  se elimina una db que pueda haber existido antes
          new PouchDB(tmpDBName)
            .destroy()
            //  se crea una db con el nombre del temporal
            .then(() => Promise.resolve(new PouchDB(tmpDBName)))
            //  se replica cla db con el filtro de que solo lo haga con los recursos no borrados
            .then(
              tmpDB =>
                new Promise((resolve, reject) => {
                  db.replicate
                    .to(tmpDB, { filter: deleteFilter })
                    .on('complete', () => {
                      resolve(tmpDB);
                    })
                    .on('denied', reject)
                    .on('error', reject);
                })
            )
            //  destruir la db
            .then(tmpDB => {
              return db.destroy().then(() => Promise.resolve(tmpDB));
            })
            //  recrear la db original
            .then(
              tmpDB =>
                new Promise((resolve, reject) => {
                  try {
                    resolve({
                      db: new PouchDB('gestor_contenidos_db'),
                      tmpDB: tmpDB
                    });
                  } catch (e) {
                    reject(e);
                  }
                })
            )
            //  replicar la db temporal a la db original
            .then(
              ({ db, tmpDB }) =>
                new Promise((resolve, reject) => {
                  tmpDB.replicate
                    .to(db)
                    .on('complete', () => {
                      resolve(tmpDB);
                    })
                    .on('denied', reject)
                    .on('error', reject);
                })
            )
            //  destruir la db temporal
            .then(tmpDB => tmpDB.destroy())
            .then(() => {
              setdb(PouchDB('gestor_contenidos_db'));
            })
            .catch(err => {
              console.log(err);
            });
        });
      })
      .then(result => {
        deleteObjetcData(object_id);
        toast.dismiss();
        setDown(datos.length - 1);
        toast.success(t('toast_eliminado'));
      })
      .catch(err => {
        toast.dismiss();
        toast.error(t('toast_completar_accion'));
      });
  };

  return (
    <div>
      <div
        style={{ backgroundColor: '#FAC600', width: '100%', height: '12px' }}
      >
        {' '}
      </div>

      <ol className="breadcrumb m-0">
        <li className="breadcrumb-item">
          <Link to="/" title={'dashboard'}>
            <i className="fal fa-home"> </i>
            <span> {t('catalogo')}</span>
          </Link>
        </li>

        <li className="breadcrumb-item active">
          <i className="fal fa-download"> </i>{' '}
          <span className=""> {t('descargas')}</span>
        </li>
      </ol>

      <div className="options">
        {down ? (
          <div>
            <div className="form-group">
              <form onSubmit={findObject}>
                <div className="input-group input-group-lg mb-5 shadow-1 rounded">
                  <input
                    type="text"
                    className="form-control shadow-inset-2 roboto-pwa"
                    id="busqueda"
                    aria-label="Escribir más de dos letras"
                    placeholder={t('buscar_descargas')}
                    value={search}
                    onChange={updateSearch}
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-default waves-effect waves-themed"
                      type="submit"
                    >
                      <i className="far fa-search mr-lg-2"> </i>
                    </button>
                  </div>
                </div>
                {inSearch ? (
                  <h1 className="mb-4 related-resources-title-pwa">
                    {' '}
                    {numRes} {t('landing_resultados_encontrados')}{' '}
                    {"'" + query_search + "'"}
                  </h1>
                ) : (
                  ''
                )}
              </form>
              {inSearch ? (
                <button
                  type="button"
                  onClick={() => {
                    get_db_elements();
                    setSearch('');
                    setQuerySearch('');
                    setIsType(true);
                    setInSearch(false);
                  }}
                  title={t('landing_reiniciar_busqueda')}
                  className="btn btn-sm btn-default btn-pills waves-effect waves-themed"
                >
                  <i className="far fa-redo"> </i>{' '}
                  {t('landing_reiniciar_busqueda')}
                </button>
              ) : (
                ''
              )}
            </div>

            {!inSearch ? (
              <ul className="nav nav-pills" role="tablist">
                <li className="nav-item" onClick={() => get_db_elements()}>
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#js_pill_border_icon-1"
                  >
                    <i className="fal fa-check mr-1"> </i>
                    {t('todos')}
                  </a>
                </li>
                <li
                  className="nav-item"
                  onClick={() => get_file_type_elements('docs')}
                >
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#js_pill_border_icon-2"
                  >
                    <i className="fal fa-file-pdf mr-1"> </i>
                    {t('documentos')}
                  </a>
                </li>
                <li
                  className="nav-item"
                  onClick={() => get_file_type_elements('img')}
                >
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#js_pill_border_icon-3"
                  >
                    <i className="fal fa-image mr-1"> </i>
                    {t('imagenes')}
                  </a>
                </li>
                <li
                  className="nav-item"
                  onClick={() => get_file_type_elements('audio')}
                >
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#js_pill_border_icon-4"
                  >
                    <i className="fal fa-file-audio mr-1"> </i>
                    {t('audio')}
                  </a>
                </li>
                <li
                  className="nav-item"
                  onClick={() => get_file_type_elements('others')}
                >
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#js_pill_border_icon-5"
                  >
                    <i className="fal fa-file mr-1"> </i>
                    {t('otros')}
                  </a>
                </li>
              </ul>
            ) : (
              ''
            )}

            <div
              id="js_list_accordion"
              className="accordion accordion-hover accordion-clean js-list-filter mt-5"
            >
              {is_type
                ? ''
                : !inSearch && (
                    <div
                      className="alert border-info bg-transparent text-info"
                      role="alert"
                    >
                      <strong>Info!</strong> {t('no_tipo_recurso')}
                    </div>
                  )}

              {datos.map(elemento => (
                <DownloadedElement
                  key={elemento.object.id}
                  type={''}
                  id={elemento.object.id}
                  nombre={elemento.object.general.title.value}
                  description={elemento.object.general.description[0].value}
                  deleteObject={() =>
                    submit(
                      elemento.object.id,
                      elemento.object.general.title.value
                    )
                  }
                />
              ))}
            </div>
          </div>
        ) : (
          <EmptyList
            message={t('empty_para_descargar')}
            c_message={t('empty_no_descargas')}
          />
        )}
      </div>
    </div>
  );
};

export default DownloadedList;
